import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import type { FishIQAreaRead, FishIQPredictionReadSource } from '../types';

export type RecordFishIQPredictionReadInput = {
  source: FishIQPredictionReadSource;
  anchor: { lat: number; lng: number };
  areaRead: FishIQAreaRead;
};

export type RecordFishIQPredictionReadResult = {
  readId: string;
  predictedAtMs: number;
  expiresAtMs: number;
  predictionCount: number;
  reused: boolean;
};

const recordPredictionReadCallable = httpsCallable<
  RecordFishIQPredictionReadInput,
  RecordFishIQPredictionReadResult
>(functions, 'recordFishIQPredictionRead');

export async function recordFishIQPredictionRead(
  input: RecordFishIQPredictionReadInput,
): Promise<RecordFishIQPredictionReadResult> {
  const response = await recordPredictionReadCallable(input);
  return response.data;
}
